import { Timer, MonitorOff, PauseCircle } from "lucide-react";

export function ScreenTimeSection() {
  return (
    <section className="space-y-6">
      <div className="text-center space-y-2">
        <h2 className="text-2xl font-display font-bold">Bygger vaner – ikke skjermtid</h2>
        <div className="text-sm text-muted-foreground max-w-md mx-auto space-y-1">
          <p>Flyt er laget for korte økter: åpne → gjør gjøremål → ferdig.</p>
          <p>Ingen algoritmer. Ingen innholdsspiraler. Ingen design som prøver å holde barnet fanget.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-lg mx-auto text-left">
        {[
          { icon: Timer, text: "Korte økter, tydelig slutt" },
          { icon: MonitorOff, text: "Ingen uendelig scroll / innhold" },
          { icon: PauseCircle, text: "Støtter pauser – ikke kontinuerlig bruk" },
        ].map((item) => (
          <div key={item.text} className="flex items-start gap-3 p-3">
            <item.icon className="h-5 w-5 text-primary mt-0.5 shrink-0" />
            <p className="text-sm">{item.text}</p>
          </div>
        ))}
      </div>
      <p className="text-center text-lg md:text-xl font-display font-bold text-foreground max-w-md mx-auto pt-4">
        Målet er at barnet skal bruke Flyt mindre over tid — fordi vanene sitter.
      </p>
      <div className="text-center max-w-md mx-auto mt-10 py-10 border-t border-b border-border space-y-2">
        <p className="text-muted-foreground">Målet er ikke at barnet skal bruke Flyt mye.</p>
        <p className="text-lg md:text-xl font-display font-bold text-foreground">Målet er at barnet skal klare seg selv.</p>
      </div>
    </section>
  );
}
